import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Product } from '@isophi/teachers-shared';

@Component({
    selector: 'app-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductCardComponent {
  @Input() hasLicense: boolean;

  @Input() product: Product;
}
